import {
  Dropdown,
  Field,
  Item,
  Menu,
  Select
} from "@zendeskgarden/react-dropdowns";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { currentLanguageChanged } from "../../actions";
import TranslationService, { t } from "../../translations/translation.service";
import eluminiLogo from "../../images/logo-elumini.png";
import eluminilogomobile from "../../images/logo-elumini-mobile.png";
import eluminiYellow from "../../images/logo-elumini-yellow.png";
import enterColor from "../../images/enter-logo.png";
// @ts-ignore
import "./index.css";
import { Link } from "react-router-dom";

class Header extends React.Component<any> {
  state = {
    currentLang: TranslationService.getCurrentLanguage,
  };
  async componentDidMount() {
    const { currentLanguageChanged } = this.props;
    currentLanguageChanged(this.state.currentLang);
  }

  render() {
   const { currentLanguageChanged } = this.props;
   currentLanguageChanged(this.state.currentLang);
    const langs = TranslationService.getLanguages();
    return (
      <div className="header">
        <div className="container container-custom">
          <div className="row align-items-center">
             <Link to="/" className="elumini-wrapper elumini-wrapper-mobile">
               {/* Desktop */}
               <img
                 src={eluminiLogo}
                 alt="Elumini Logo"
                 className="logo-elumini elumini-black desktop-only"
               />
               <img
                 src={eluminiYellow}
                 alt="Elumini Logo"
                 className="logo-elumini elumini-yellow desktop-only"
               />

               {/* Mobile */}
               <img
                 src={eluminilogomobile}
                 alt="Elumini Logo Mobile"
                 className="logo-elumini-mobile mobile-only"
               />
             </Link>
            <div className="col d-flex justify-content-end align-items-center gap-3">
              <Dropdown
                 selectedItem={TranslationService.getCurrentLanguage()}
                 onSelect={(selectedLang) => {
                  TranslationService.changeLanguage(selectedLang);
                  this.setState({ currentLang: selectedLang });
                  currentLanguageChanged(selectedLang);
                }}
                downshiftProps={{
                  itemToString: (item: any) => item,
                }}
              >
                <Field>
                  <Select className="u-semi u-fs-sm border-0 language-select">
                    {t(TranslationService.getCurrentLanguage())}
                  </Select>
                </Field>
                <Menu className="u-fs-sm">
                  {langs.map((option: any) => (
                    <Item key={option} value={option}>
                      {t(option)}
                    </Item>
                  ))}
                </Menu>
              </Dropdown>
              <img
                src={enterColor}
                alt="Enter Logo"
                className="enter-color"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store: {
  changeLanguageReducer: { currentLanguage: string };
}) => ({
  currentLanguage: store.changeLanguageReducer.currentLanguage,
});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      currentLanguageChanged,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
